import React from 'react';
import RasffDashboard from '../components/dashboard/RasffDashboard';
import UpcomingLegislationCard from '../components/dashboard/UpcomingLegislation';
import PendingKnowledge from '../components/dashboard/PendingKnowledge';
import PesticideSearch from '../components/dashboard/PesticideSearch';
import IncidentBanner from '../components/IncidentBanner';
import { usePageMeta } from '../hooks/usePageMeta';

export default function DashboardPage() {
  usePageMeta({ title: 'RASFF notifications, recalls and pesticide MRLs', description: 'RASFF notifications by hazard, product and origin, food safety incidents, EU legislation in the pipeline and a search across EU pesticide MRLs.' });
  return (
    <div className="dash-layout">
      <h1 className="sr-only">Food Safety Digest — RASFF Dashboard</h1>
      <IncidentBanner />
      <RasffDashboard />
      <div className="dash-bottom-row">
        <UpcomingLegislationCard />
        <PendingKnowledge />
        <PesticideSearch />
      </div>
    </div>
  );
}
